import { render, staticRenderFns } from "./StudentRequests.vue?vue&type=template&id=39396bf8"
import script from "./StudentRequests.vue?vue&type=script&lang=js"
export * from "./StudentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports